module.exports = __webpack_public_path__ + "img/deviceSystem_1.9173cb59.jpg";